import billOffer from "./bill-offer";

export default {
    billOffer
}